import {
  NewFooter,
  NewHeader,
  SegmentAnalytics
} from "components";
import React, { useEffect } from "react";

import Head from "next/head";
import PartnerGlobalStyle from "static/next/css/PartnerGlobalStyle";
import { ToastContainer } from "react-toastify";
import { WealthyEnv } from "helpers";
import styled from "styled-components";

const heroImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/hero-founder-letter-about-us.jpg`;

const IndexPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
  }, []);

  return (
    <>
      <PartnerGlobalStyle />
      <link
        href="https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap"
        rel="stylesheet"
      />
      <Head>
        <title>Grow Your Business with Wealthy – Become a Mutual Fund Distributor</title>
        <meta content="Grow Your Business with Wealthy – Become a Mutual Fund Distributor" name="title" />
        <meta content="Partner with Wealthy to expand your business with a wide range of products, advanced portfolio tracking, and automated payouts." name="description" />
        <meta content="Wealthy, Wealthy India, mutual fund distributor, mutual fund platform, investment professionals, financial entrepreneurs, PMS, insurance, fixed deposits, debentures, MFD tools, distributor platform, investment products, grow business, revenue share, partner program, mutual funds online, client management tools, portfolio tracking, digital investment platform India, financial product distribution, NISM, commission of mutual fund distributor" name="keywords" />
        {/* <link href={`${WealthyEnv.URL}/about-us`} rel="canonical" /> */}
        <link href="https://i.wlycdn.com/wealthy-home-page/new-fav-icon.png" rel="icon" />
        {/* <link as="style" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css" rel="preload" />
        <link as="style" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css" rel="preload" /> */}
        <link as="style" href="static/next/css/header-footer.css" rel="preload" />
        {/* <link href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css" rel="stylesheet" />
        <link href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css" rel="stylesheet" />
        <link href="static/next/css/ReactToastify.min.css" rel="stylesheet"  /> */}
        <link href="static/next/css/header-footer.css" rel="stylesheet" />
        {/* <script src={`https://www.google.com/recaptcha/api.js?render=${WealthyEnv.RECAPTCHA_SITEKEY}`} /> */}
      </Head>
      <SegmentAnalytics />
      <ToastContainer />

      {<PartnerGlobalStyle />}

      <NewHeader
        backgroundColor={"#fffff"}
        color={"#000000"}
        logo={`${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-new-purple-logo.svg`}
      />
      <main id="main-content">
      <Section>
        <LetterContainer>
          <Heading>
            A letter from Aditya Aggarwal and {"\n"} Prashant Gupta, Our Founders
          </Heading>
          <FounderImage
            src={heroImage}
            alt="Founders"
          />
          <Intro>
            Wealth management in India is broken!<br />
            <b>But Wealthy is fixing it.</b>
          </Intro>
          <SubHeading>The Problem</SubHeading>
          <Paragraph>
            Today, if an individual is looking for help in managing his money, his choices come with glaring issues.
          </Paragraph>
          <Paragraph>
            For one, he could go to his bank, but he won't get tailored investment advice. It's a one-size fits all approach unless he's a high net worth individual, of course. If not for banks, he could use one of the many investment apps out there but there's no face on the other side of the table with whom he can have conversations about his dreams and goals. It's quite lonely. Finally, if he decides to turn to an independent Mutual Fund Distributor (MFD), he'll get the conversation, but, in return, he's limited to investing in just mutual funds and he'll get a shoddy platform to track his assets.
          </Paragraph>
          <Paragraph>
            See the Problem?
          </Paragraph>
          <Paragraph>
            Prashant and I saw it too. We also knew that things had to change quickly. Especially since more Indians were climbing up the income ladder and looking for help in managing their money.
          </Paragraph>
          <SubHeading>Our Solution</SubHeading>
          <Paragraph>
            So we decided that we would build something that would not only enable the MFD community to scale their business, but also attract more people to become MFDs. Yes, the other problem was that India didn't have enough of them – just 1 MFD for every 11,500 Indians.
          </Paragraph>
          <Paragraph>
            And to help MFDs, we built Wealthy on a foundation 3 pillars:
          </Paragraph>
          <List>
            <li>
              Products – We wanted MFDs to be able to offer their clients access to not just mutual funds but across bonds, insurance, corporate fixed deposits, and even PMS. With the added advantage of a curated basket of products chosen by experts.
            </li>
            <li>
              Tech & Design – But to offer those products, MFDs need a cutting-edge investment platform with a stunning user interface that would have a seamless investment process no matter whether it was a mutual funds investment and an insurance proposal. So we built that.
            </li>
            <li>
              Business Support – Even MFDs need to have conversations. Especially regarding their business goals. So we built a team of dedicated Relationship Managers to help MFDs operationally and even guide them on scaling their business.
            </li>
          </List>
          <ParagraphLower>
            What's the end result of all this?
          </ParagraphLower>
          <ParagraphLower>
            Wealthy — disruptive wealthtech business that has already helped over 4,000 MFDs build their dream careers and scale existing businesses higher!
          </ParagraphLower>
          <ParagraphLower>
            And this is just the beginning. Wealthy has a lot more in store.
          </ParagraphLower>
          <CTAButton href="https://www.wealthy.in/partner#register">Become a Wealthy Partner today!</CTAButton>
        </LetterContainer>
      </Section>
      </main>
      <NewFooter />
    </>
  );
};

const Section = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  background: #fff;
  padding: 4.8rem 0;
  overflow-x: hidden;
  box-sizing: border-box;
  margin-bottom: 8rem;

  @media (max-width: 700px) {
    padding: 0;
  }
`;

const LetterContainer = styled.div`
  width: 70%;
  margin: 0 auto;
  background: #fff;
  border-radius: 1.2rem;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: 95%;
    padding: 2rem;
  }
`;

const Heading = styled.h1`
  font-family: 'DM Serif Display';
  font-size: 5.6rem;
  width: 100%;
  font-weight: 400;
  text-align: left;
  margin-bottom: 3.2rem;
  color: #222;
  align-self: center;
  white-space: pre-line;
  line-height: 1.2;

  @media (max-width: 768px) {
    width: 66%;
    font-size: 2.7rem;
  }
`;

const FounderImage = styled.img`
  width: 50%;
  border-radius: 1rem;
  margin-bottom: 3.2rem;
  object-fit: cover;

  @media(max-width: 768px){
    width: 100%;
  }
`;

const Intro = styled.p`
  font-size: 2.4rem;
  color: #000000;
  line-height: 3.2rem;
  font-family: 'Lato';
  text-align: left;
  margin-bottom: 3.2rem;
  font-weight: 400;
  width: 100%;
  b {
    font-weight: bold;
    font-size: 2.22rem;
  }

  @media (max-width: 768px) {
    font-size: 1.77rem;
  }
`;

const SubHeading = styled.h1`
  font-family: 'DM Serif Display';
  font-size: 4.2rem;
  line-height: 3.2rem;
  font-weight: 400;
  color: #1C1C1C;
  margin: 3.2rem 0 1.6rem 0;
  text-align: left;
  width: 100%;

  @media (max-width: 768px) {
    font-size: 2.7rem;
  }
`;

const Paragraph = styled.p`
  font-size: 2rem;
  font-family: 'Lato';
  color: #7E7E7E;
  line-height: 32px;
  margin-bottom: 1.8rem;

  @media (max-width: 768px) {
    font-size: 1.77rem;
  }
`;

const ParagraphLower = styled.p`
  font-size: 2rem;
  font-family: 'Lato';
  color: #1C1C1C;
  line-height: 3.2rem;
  margin-bottom: 1.8rem;

  @media (max-width: 768px) {
    font-size: 1.77rem;
  }
`;

const List = styled.ol`
  font-size: 2rem;
  font-family: 'Lato';
  color: #7E7E7E;
  line-height: 3.2rem;
  margin-bottom: 2.4rem;
  width: 100%;
  padding-left: 2.4rem;

  li {
    margin-bottom: 2rem;
    line-height: 3.2rem;
  }

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

const CTAButton = styled.a`
  background: #6725F4;
  font-family: 'Lato';
    color: #fff;
    border: none;
    width: 30%;
    text-align: center;
    border-radius: 3rem;
    padding: 1.5rem .5rem;
    font-size: 1.8rem;
    font-weight: bold;
    cursor: pointer;
    margin-top: 1.5rem;


  @media (max-width: 768px) {
    width: 100%;
    margin: auto;
  }
`;

export default IndexPage;
